"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Eip191Signer = void 0;
const protocol_contract_client_1 = require("@moojo/protocol-contract-client");
const protocol_core_1 = require("@moojo/protocol-core");
const viem_1 = require("viem");
const accounts_1 = require("viem/accounts");
/**
 * Facility for create EIP-191 signatures signed with specific private key (wallet).
 * EIP-191 defines a standard for signing arbitrary data with Ethereum accounts.
 * It provides a method to sign messages and verify signatures, ensuring that
 * the signed data can be attributed to a specific Ethereum address.
 *
 * https://eips.ethereum.org/EIPS/eip-191
 */
class Eip191Signer {
    client;
    constructor(key, urlOrProvider) {
        this.client = (0, viem_1.createWalletClient)({
            account: (0, accounts_1.privateKeyToAccount)((0, protocol_core_1.hexify)(key.toString())),
            transport: (0, protocol_contract_client_1.makeTransport)(urlOrProvider), // no really needed
        });
    }
    /**
     * Returns EIP-191 signature for a given message hash.
     */
    sign(hash) {
        return this.client.signMessage({ message: { raw: hash } });
    }
}
exports.Eip191Signer = Eip191Signer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWlwMTkxLXNpZ25lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zaWduL2VpcDE5MS1zaWduZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsOEVBQStEO0FBQy9ELHdEQUErRDtBQUUvRCwrQkFBeUM7QUFDekMsNENBQW1EO0FBRW5EOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLFlBQVk7SUFDTixNQUFNLENBQUE7SUFFdkIsWUFBWSxHQUFlLEVBQUUsYUFBd0M7UUFDbkUsSUFBSSxDQUFDLE1BQU0sR0FBRyxJQUFBLHlCQUFrQixFQUFDO1lBQy9CLE9BQU8sRUFBRSxJQUFBLDhCQUFtQixFQUFDLElBQUEsc0JBQU0sRUFBQyxHQUFHLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQztZQUNwRCxTQUFTLEVBQUUsSUFBQSx3Q0FBYSxFQUFDLGFBQWEsQ0FBQyxFQUFFLG1CQUFtQjtTQUM3RCxDQUFDLENBQUE7SUFDSixDQUFDO0lBRUQ7O09BRUc7SUFDSCxJQUFJLENBQUMsSUFBWTtRQUNmLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQyxXQUFXLENBQUMsRUFBRSxPQUFPLEVBQUUsRUFBRSxHQUFHLEVBQUUsSUFBSSxFQUFFLEVBQUUsQ0FBQyxDQUFBO0lBQzVELENBQUM7Q0FDRjtBQWhCRCxvQ0FnQkMifQ==